(ns app.front.view.inspections.visit.failure-reason
  (:require [app.domain.inspection.model :as inspection-model]
            [app.front.entity-edit :as ee]
            [app.front.ui.radio :as ui-radio]
            [app.front.view.inspections.deficiencies-v2 :as deficiencies-v2]
            [app.front.view.inspections.visit.result-detail :as result-detail]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::failure-reasons
  :<- [::deficiencies-v2/create-signal]
  (fn [deficiency-signal [_ current-value]]
    (let [allowed-values (cond-> inspection-model/base-failure-reasons
                           (= deficiency-signal :process.signal/create-inspection-violation) (conj :inspection.visit.failure/violations)
                           (= deficiency-signal :process.signal/create-inspection-deficiency) (conj :inspection.visit.failure/deficiencies)
                           true (conj :inspection.visit.failure/order-issued))]
      ;; add current value if allowed values do not contain it
      (if (or (nil? current-value)
              (some #{current-value} allowed-values))
        allowed-values
        (conj allowed-values current-value)))))

(rf/reg-sub ::disabled-failure-reasons
  :<- [::deficiencies-v2/deficiencies?]
  (fn [deficiencies? _]
    (when (not deficiencies?)
      #{:inspection.visit.failure/deficiencies})))

(defn failure-reason-picker [{:keys [visit-id tr set-value]}]
  (let [failure-reason (or (<sub [::ee/attr-value visit-id :inspection.visit/failure-reason])
                           :inspection.visit.failure/info-required)
        on-change      (partial set-value :inspection.visit/failure-reason)]
    [:div.align-bottom.inline-block.mb-2.mr-2
     [ui-radio/radio
      {:values          (<sub [::failure-reasons failure-reason])
       :disabled-values (<sub [::disabled-failure-reasons])
       :name            "failure-reason"
       :label-text      (or (<sub [::result-detail/result-detail-label :inspection.visit.result/failed])
                            (tr [:inspection.visit/failure-reason]))
       :val->str        #(tr [%])
       :on-change       on-change
       :value           failure-reason
       :required        true
       :allow-empty?    false}]]))
